import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {CameraService} from '../../services/camera/camera.service';
import {UploadService} from '../../services/upload.service';

@Component({
  selector: 'app-local',
  templateUrl: './local.component.html',
  styleUrls: ['../../app.component.scss', './local.component.scss']
})
export class LocalComponent implements OnInit, AfterViewInit, OnDestroy {
  mediaReady = false;

  constructor(public cameraService: CameraService,
              public uploadService: UploadService) {
  }

  ngOnInit(): void {
    const videoElement: HTMLVideoElement = document.getElementById('localVideoElement') as HTMLVideoElement;
    const canvasImage: HTMLCanvasElement = document.getElementById('canvasLocalOutput') as HTMLCanvasElement;
    // const landmarkContainer = document.getElementsByClassName('landmark-grid-container')[0];
    this.cameraService.initVideoElement(videoElement, canvasImage/*, landmarkContainer*/);
  }

  ngAfterViewInit(): void {
    this.mediaReady = false;
    this.cameraService.startCamera(async (stream: MediaStream) => {
      this.mediaReady = true;
      console.log(this.cameraService.prepared);
      await this.cameraService.prepareAllModels();
      setTimeout(() => {
        this.cameraService.copyToCanvas();
      }, 1000);
    });
  }

  ngOnDestroy(): void {
    this.cameraService.stopCamera();
  }

}
